<template>
  <VyButton v-bind="$attrs" class="button--circle button--muted" />
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
